import React, { useCallback } from 'react';

import { PAYMENT_MODE } from '@src/components/Checkout/constants';
import { AdditionalInfoCard } from '@src/features/orders/form-inputs';
import { useCheckoutNavigation } from '@src/views/checkout/CheckoutFlowContext';

export const CheckoutAdditionalInfoStep = () => {
  const { goTo } = useCheckoutNavigation();

  const goToPayment = useCallback(() => goTo(PAYMENT_MODE), [goTo]);

  return (
    <div data-testid='checkout-additional-info-step'>
      <AdditionalInfoCard onCompleted={goToPayment} />
    </div>
  );
};

export default CheckoutAdditionalInfoStep;
